import { render } from "./ParentalConsent.vue?vue&type=template&id=592758be&scoped=true"
import script from "./ParentalConsent.vue?vue&type=script&lang=js"
export * from "./ParentalConsent.vue?vue&type=script&lang=js"

import "./ParentalConsent.vue?vue&type=style&index=0&id=592758be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592758be"]])

export default __exports__